import axiosInstance from "../../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class PatientService {
  addPatient = async (patientData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.PATIENTS.ADD, patientData);
      return response.data;
    } catch (error) {
      console.log("Bir sorun oluştu:", error.response?.data || error.message);
      throw error;
    }
  };

  getAllPatients = async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.PATIENTS.ALL);
      return response.data;
    } catch (error) {
      console.log("Tüm hasta bilgilerni getirirken bir hata oluştu.");
    }
  };
  
  getPatientInfo = async (data) =>{
    try{
        const response = await axiosInstance.get(API_ENDPOINTS.PATIENTS.BY_ID(data))
        return response.data
    }catch(error){
        console.log("Bir sorun oluştu:", error.response?.data || error.message)
        throw error;
    }
  }
  
  deletePatient = async (data)=>{
    try{
      const response = await axiosInstance.delete(API_ENDPOINTS.PATIENTS.DELETE(data))
      return response.data
    }catch(error){
      console.log("Bir sorun oluştu:", error?.response?.data || error.message)
      throw error;
    }
  }
  
  updatePatient = async (patientId,updatedData)=>{
    try{
      const response = await axiosInstance.put(API_ENDPOINTS.PATIENTS.UPDATE(patientId), updatedData);
      return response.data;
    }catch(error){
      console.log("Bir sorun oluştu.", error.response?.data || error.message);
      throw error;
    }
  }
}
